import React, { useEffect, useState, useRef } from "react";
import { jsPDF } from "jspdf";
import moment from "moment";
import { FaSpinner } from "react-icons/fa";
import { base64ToBlobAndURL, formatCurrency, stripHTML } from "../../common-components/commonFunctions";
import Loading from "../../common-components/Loader";
import PdfViewer from "../../common-components/PdfViewer";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const ResumePDFGenerator = (data: any) => {
  const[isLoading,setIsloading]=useState<boolean>(false)
  const[isDownloading, setIsDownloading] = useState<boolean>(false);
  const detailsPageLoading = useSelector((state:RootState) => state.detailPageReducer.isLoading);
  // Get data directly from Redux store (same source as DetailPagePdf uses)
  const DetailDataFromStore = useSelector((state:RootState) => state.detailPageReducer.data);
  const[isPdfUrl,setPdfUrl]=useState<string>("")
  const[numPages, setNumPages] = useState<number>(1);
  
  // Store data in ref once it's loaded - this persists across re-renders
  const dataRef = useRef<any>(null);
  
  // Update ref whenever data is available from any source
  useEffect(() => {
    const currentData = DetailDataFromStore?._id ? DetailDataFromStore : (data?.data || data);
    if (currentData?._id) {
      dataRef.current = currentData;
    }
  }, [DetailDataFromStore, data?.data, data]);
  
  useEffect(() => {
    if(data?.data?._id) generatePDF();
  },[data?.data?._id])

  const generatePDF = async (type?: string) => {
    // If downloading, ensure data is loaded first
    if (type === "download") {
      setIsDownloading(true);
      
      // Priority: Use ref data (saved when loaded) > Redux store > prop data
      let currentData = dataRef.current || DetailDataFromStore || (data?.data || data);
      
      // If data is not available, wait for it to load
      if (!currentData?._id) {
        // Wait up to 3 seconds for data to load, checking all sources
        for (let i = 0; i < 15; i++) {
          await new Promise(resolve => setTimeout(resolve, 200));
          // Check all sources each iteration
          currentData = dataRef.current || DetailDataFromStore || (data?.data || data);
          if (currentData?._id) {
            // Save to ref for future use
            dataRef.current = currentData;
            break;
          }
        }
        
        // Final check - if still no data, show alert
        if (!currentData?._id) {
          alert("Please wait for data to load completely before downloading PDF.");
          setIsDownloading(false);
          return;
        }
      }
      
      // Ensure ref has the latest data
      if (currentData?._id && !dataRef.current) {
        dataRef.current = currentData;
      }
      
      // Wait a bit more to ensure all async data (especially images) is loaded
      await new Promise(resolve => setTimeout(resolve, 300));
    }
    
    let docPages = 0;
    setIsloading(true)
    
    // Use data from ref (most reliable - saved when loaded), fallback to other sources
    const pdfData = dataRef.current || DetailDataFromStore || (data?.data || data);
    
    // Final safety check - if still no data, try to get it one more time
    if (!pdfData?._id) {
      const lastAttempt = DetailDataFromStore || (data?.data || data);
      if (lastAttempt?._id) {
        // Use this data and save to ref
        dataRef.current = lastAttempt;
      } else {
        console.error("No data available for PDF generation");
        setIsloading(false);
        if (type === "download") {
          setIsDownloading(false);
          alert("Data is not available. Please refresh the page and try again.");
        }
        return;
      }
    }
    
    // Use the final pdfData (from ref or fallback)
    const finalPdfData = dataRef.current || pdfData;
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });
  
    let marginTop = 15;
    let marginBottom = 10;
    var currentY = marginTop;
    const checkAndAddPage = (
      doc: any,
      currentY: any,
      lineHeight: any,
      marginBottom: any,
      footerHeight: any
    ) => {
      const pageHeight = doc.internal.pageSize.height;
      let pageWidth = doc.internal.pageSize.getWidth();
      const marginPadding = 3;
      const headerHeight = 10;
      const headerBottomPadding = 3;
      const contentHeight =
        pageHeight - headerHeight - footerHeight - 1 * marginPadding + 10;
      const contentTop = headerHeight + marginPadding + headerBottomPadding;
      const availableHeight =
        pageHeight -
        marginBottom -
        footerHeight - headerBottomPadding -
        1 * marginPadding;

      doc.setLineWidth(0.2);
      doc.setDrawColor(0, 0, 0);
      doc.rect(
        marginPadding,
        contentTop,
        pageWidth - 2 * marginPadding,
        contentHeight
      );


      const canvas = document.createElement("canvas");
      canvas.width = 2100;
      canvas.height = 100;
      const ctx = canvas.getContext("2d");
      if (ctx) {
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        gradient.addColorStop(0, "#E74C3C");
        gradient.addColorStop(1, "#FFF5F5");
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        try {
          doc.addImage(
            canvas.toDataURL("image/JPEG"),
            "JPEG",
            marginPadding,
            marginPadding,
            pageWidth - 2 * marginPadding,
            headerHeight
            // undefined,
            // "FAST"
          );
          // doc.setTextColor(255, 255, 255);
          // doc.setFontSize(14);
          // doc.setFont("helvetica", "bold");
          // const leftText = data.data.TESTIMPRINTFROMHNA;
          // const rightText =data.data.SEASON ;
          // const leftTextX = 10;
          // const rightTextX = pageWidth + 4 - doc.getTextWidth(rightText);
          // doc.text(leftText, leftTextX, 10);
          // doc.setTextColor(0, 0, 0);
          // doc.setFontSize(8);
          // doc.text(rightText, rightTextX, 10);
          // doc.setTextColor(0, 0, 0);
          // doc.setFontSize(10);
          // doc.setFont("helvetica", "normal");
          const leftText = finalPdfData?.TESTIMPRINTFROMHNA || "";
      const rightText = finalPdfData?.SEASON || "";
      const margin = 10;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
     doc.setTextColor(255, 255, 255);
     doc.text(leftText, margin, 10);
     doc.setTextColor(0, 0, 0);
     doc.setFontSize(8);
     const rightTextX = pageWidth - margin - doc.getTextWidth(rightText);
doc.text(rightText, rightTextX, 10);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
        } catch (error) {
          console.error("Error adding gradient:", error);
        }
      }

        if (currentY + lineHeight > availableHeight) {
        if(type !== "download"){
          setNumPages(old => old+=1);
        }
        docPages+=1;
        doc.addPage();
        return 20;
      }
      if(docPages === 0)
        doc.rect(
          150,
          20,
          40,
          40
        );
      return currentY;
    };

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    const leftColumnX = 10;
    currentY += 10;
    doc.setFontSize(12);

    const fields = [
      { key: "ISBN", value: finalPdfData?.EAN || "" },
      { key: "TITLE", value: finalPdfData?.FULL_TITLE || "" },
    ];
    const keyFontSize = 10;
    const valueFontSize = 10;
    const lineHeight = 7;
    fields.forEach(({ key, value }) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(keyFontSize);
      doc.text(`${key}:`, leftColumnX, currentY);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(valueFontSize);
      const valueX = leftColumnX + 12;
      doc.text(`${value}`, valueX, currentY, { maxWidth: 120 });
      currentY += lineHeight;
    });

    // Handle image - ensure it's loaded
    let imageUrl = null;
    try {
      if (finalPdfData?.imageBase64String && finalPdfData?.imageBase64String !== "404" && finalPdfData?.imageBase64String?.length) {
        imageUrl = await base64ToBlobAndURL(finalPdfData?.imageBase64String);
        // Wait a bit to ensure image is fully processed
        await new Promise(resolve => setTimeout(resolve, 200));
      }
    } catch (error) {
      console.error("Error processing image:", error);
    }
    // else {
    //   const response = await fetch(noDataFoundImage);
    //   const blob = await response.blob();
    //   imageUrl = URL.createObjectURL(blob);
    // }
    if (imageUrl) {
      const imageX = 150;
      const imageY = 20;
      const imageWidth = 40;
      const imageHeight = 40;

      try {
        doc.addImage(imageUrl, "JPEG", imageX, imageY, imageWidth, imageHeight);
      } catch (error) {
        console.error("Error adding image to PDF:", error);
      }
    }
    const pages = 8;
    doc.setDrawColor(0);
    doc.setLineWidth(0.1);
    doc.line(
      pages,
      currentY + 25,
      doc.internal.pageSize.width - pages,
      currentY + 25
    );

    const footerHeight = 20; 
    const leftFields = [
      { key: "AUTHOR", value: finalPdfData?.AUTHOR_1 || "" },
      { key: "RELEASE DATE", value: finalPdfData?.RELEASE_DATE?.length > 2 ? moment(finalPdfData?.RELEASE_DATE).format("MM/DD/YYYY") : "" },
      { key: "PUB MONTH", value: finalPdfData?.PUBMONTH || "" },
      { key: "ON SALE-DATE", value: finalPdfData?.PUB_DATE?.length > 2 ? moment(finalPdfData?.PUB_DATE).format("MM/DD/YYYY") : "" },
      { key: "AGE RANGE", value: finalPdfData?.AGE_RANGE || "" },
      {
        key: "PRICE",
        value: `${finalPdfData?.US_PRICE ? `${formatCurrency(finalPdfData?.US_PRICE,2,"noSign")}USD${(finalPdfData?.CANADIAN_PRICE || finalPdfData?.UK_PRICE) ? "/ ": ""}` : ""}${finalPdfData?.CANADIAN_PRICE ? `${formatCurrency(finalPdfData?.CANADIAN_PRICE,2,"noSign")}CAN${(finalPdfData?.UK_PRICE) ? "/ ": ""}` : ""} ${finalPdfData?.UK_PRICE ? `${formatCurrency(finalPdfData?.UK_PRICE,2,"noSign")}UK` : ""}`,
      },
      {
        key: "ANNOUNCED 1ST PRINTING BEST",
        value: finalPdfData?.ANNOUNCED_1ST_PRINTING__BEST || "",
      },
      { key: "ORIGIN", value: finalPdfData?.ORIGIN || "" },
      { key: "AUTHOR BY LINE", value: finalPdfData?.AUTHOR_1 || "" },
    ];

    const rightFields = [
      { key: "EDITOR", value: finalPdfData?.EDITOR || "" },
      { key: "SERIES", value: finalPdfData?.SERIES || "" },
      { key: "FORMAT", value: finalPdfData?.FORMAT || "" },
      { key: "PAGE COUNT", value: finalPdfData?.PAGES || "" },
      { key: "ILLUS/INSERT", value: finalPdfData?.INSERTS_ILLUS || "" },
      {
        key:"BISAC SUBJECT(S)",
        value: `${finalPdfData?.BISAC1_DESC || ""} ${
          finalPdfData?.BISAC2_DESC || ""
        } ${finalPdfData?.BISAC3_DESC || ""}`,
      },
    ];
    marginTop = 70;
    var currentY = marginTop;
    const pageWidth = doc.internal.pageSize.width;
    const middleX = pageWidth / 2;
    doc.setDrawColor(0);
    doc.setLineWidth(0.23);
    marginTop -= 5;
    doc.line(middleX, marginTop, middleX, doc.internal.pageSize.height - 142);
    marginTop += 5;
    
    leftFields.forEach(({ key, value }) => {
      const keyFontSize = 9.5;
      const valueFontSize = 9;
      const lineHeight = 9;
      const keyWidth = 40;
      const valueWidth = 50;
    
      currentY = checkAndAddPage(
        doc,
        currentY,
        lineHeight,
        marginBottom,
        footerHeight
      );
      doc.setFontSize(keyFontSize);
      doc.setFont("helvetica", "bold");
      doc.text(`${key}:`, 10, currentY, { maxWidth: keyWidth });
      doc.setFontSize(valueFontSize);
      doc.setFont("helvetica", "normal");
      doc.text(`${value}`, 50, currentY, { maxWidth: valueWidth });
      if (key === "ANNOUNCED 1ST PRINTING BEST") {
        currentY += lineHeight + 3; 
      } else {
        currentY += lineHeight;
      }
    
    });
    let rightFieldsStartY = marginTop;
    rightFields.forEach(({ key, value }) => {
      const keyFontSize = 9.5;
      const valueFontSize = 9;
      const lineHeight = 10;
      const keyWidth = 40;
      const valueWidth = 50;
      rightFieldsStartY = checkAndAddPage(
        doc,
        rightFieldsStartY,
        lineHeight,
        marginBottom,
        footerHeight
      );
      doc.setFontSize(keyFontSize);
      doc.setFont("helvetica", "bold");
      doc.text(`${key}:`, 110, rightFieldsStartY, { maxWidth: keyWidth });
      doc.setFontSize(valueFontSize);
      doc.setFont("helvetica", "normal");
      doc.text(`${value}`, 150, rightFieldsStartY, { maxWidth: valueWidth });
      rightFieldsStartY += lineHeight;
    });
    const pageMargin = 8;
    doc.setDrawColor(0);
    doc.setLineWidth(0.1);
    doc.line(
      pageMargin,
      currentY + 2,
      doc.internal.pageSize.width - pageMargin,
      currentY + 2
    );

    const longValue = {
      key: "Description",
      value: (finalPdfData?.DESCRIPTION && finalPdfData?.DESCRIPTION?.length > 1) ? stripHTML(finalPdfData.DESCRIPTION) : "",
    };
    var keyWidth = 40;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(keyFontSize);
    doc.text(`${longValue.key}:`, 10, (currentY += 10), { maxWidth: keyWidth });
    doc.setFont("helvetica", "normal");
    const textLines = doc.splitTextToSize(longValue.value, 155);
    textLines.forEach((line: any) => {
      const lineHeight = 6;
      currentY = checkAndAddPage(
        doc,
        currentY,
        lineHeight,
        marginBottom,
        footerHeight
      );
      doc.text(line, 40, currentY);
      currentY += lineHeight;
    });
    const ContributoR = {
      key: "Contributor Bio",
      value: (finalPdfData?.AUTHOR_BIO && finalPdfData?.AUTHOR_BIO?.length > 1) ? stripHTML(finalPdfData?.AUTHOR_BIO) : "",
    };
    var keyWidth = 40;
    doc.setFont("helvetica", "bold");
    doc.text(`${ContributoR.key}:`, 10, (currentY += 3), {
      maxWidth: keyWidth,
    });
    doc.setFont("helvetica", "normal");
    const textLine = doc.splitTextToSize(ContributoR.value, 155);
    doc.setFont("helvetica", "normal");
    textLine.forEach((line: any) => {
      const lineHeight = 6;
      currentY = checkAndAddPage(
        doc,
        currentY,
        lineHeight,
        marginBottom,
        footerHeight
      );

      doc.text(line, 40, currentY);
      currentY += lineHeight;
    });
    const Marketing = {
      key: "Marketing",
      value: (finalPdfData?.MARKETING_BULLETS__FACT_SHEET && finalPdfData?.MARKETING_BULLETS__FACT_SHEET?.length > 1) ? stripHTML(finalPdfData?.MARKETING_BULLETS__FACT_SHEET) : "",
    };
    var keyWidth = 40;
    doc.setFont("helvetica", "bold");
    doc.text(`${Marketing.key}:`, 10, (currentY += 3), { maxWidth: keyWidth });
    doc.setFont("helvetica", "normal");
    const line = doc.splitTextToSize(Marketing.value, 155);
    line.forEach((line: any) => {
      const lineHeight = 6;
      currentY = checkAndAddPage(
        doc,
        currentY,
        lineHeight,
        marginBottom,
        footerHeight
      );
      doc.text(line, 40, currentY);
      currentY += lineHeight;
    });
    const Publicity = {
      key: "Publicity",
      value: (finalPdfData?.PUBLICITY && finalPdfData?.PUBLICITY?.length > 1)  ? stripHTML(finalPdfData?.PUBLICITY) : "",
    };
    var keyWidth = 40;

    const valueStartX = 40;
    doc.setFont("helvetica", "bold");
    doc.text(`${Publicity.key}:`, 10, (currentY += 3), { maxWidth: keyWidth });
    doc.setFont("helvetica", "normal");
    const Line = doc.splitTextToSize(Publicity.value, 155);
    Line.forEach((line: any) => {
      const lineHeight = 6;
      currentY = checkAndAddPage(
        doc,
        currentY,
        lineHeight,
        marginBottom,
        footerHeight
      );
      doc.text(line, valueStartX, currentY);
      currentY += lineHeight;
    });
    const Category = {
      key: "Category(s)",
      value: `${stripHTML(finalPdfData?.CATEGORY1 ?? "") || ""} ${stripHTML(finalPdfData?.CATEGORY2 ?? "") || ""} ${
        stripHTML(finalPdfData?.CATEGORY3 ?? "") || ""
      }`,
    };
    var keyWidth = 40;

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(`${Category.key}:`, 10, (currentY += 3), { maxWidth: keyWidth });
    doc.setFont("helvetica", "normal");
    const Lines = doc.splitTextToSize(Category.value, 155);
    Lines.forEach((line: any) => {
      const lineHeight = 6;
      currentY = checkAndAddPage(
        doc,
        currentY,
        lineHeight,
        marginBottom,
        footerHeight
      );
      doc.text(line, valueStartX, currentY);
      currentY += lineHeight;
    });

    const addFooter = (pageNumber: any, totalPages: any) => {
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const footerY = pageHeight - footerHeight;
      const logoUrl = "/images/Abrams.png";
      const imgWidth = 40;
      const imgHeight = 15;
      const logoY = footerY - 6;

      try {
        doc.setDrawColor(128);
        doc.setLineWidth(0.2);
        doc.line(
          pages,
          270,
          doc.internal.pageSize.width - pages,
          270
        );
        doc.addImage(logoUrl, "PNG", 10, logoY, imgWidth, imgHeight);
      } catch (error) {
        console.error("Error adding footer image:", error);
      }

      // const currentDate = new Date().toLocaleDateString();
      const currentDate = finalPdfData?.PUB_DATE;
      const formattedDate = moment(currentDate).format("MM/DD/YYYY");
      const dateTextWidth = doc.getTextWidth(formattedDate);
      const dateTextX = (pageWidth - dateTextWidth) / 2;
      const dateY = footerY + 3;
      // doc.text(formattedDate, dateTextX, dateY);

      const pageNumberText = `Page ${pageNumber} of ${totalPages}`;
      const pageNumberTextWidth = doc.getTextWidth(pageNumberText);
      const pageNumberX = pageWidth - 10 - pageNumberTextWidth;
      const pageNumberY = footerY + 3;
      doc.text(pageNumberText, pageNumberX, pageNumberY);
    };
    const totalPages = doc.internal.pages.length - 1;
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      addFooter(i, totalPages);
    }

    doc.setFontSize(10);
    const rightColumnX = 100;
    currentY = 20;

    try {
      if(type === "download"){
        doc.save("Title-List.pdf");
        setIsDownloading(false);
        setIsloading(false);
        return;
      }
        // Generate the PDF and get it as a Blob
        const pdfBlob = doc.output("blob");
        // Create an object URL for the Blob
        const pdfUrl = URL.createObjectURL(pdfBlob);
        // Set the src of the iframe to the PDF URL
        // const iframe = document.getElementById("pdf-iframe") as HTMLIFrameElement;
        // iframe.src = pdfUrl;
        setPdfUrl(pdfUrl)
        // iframe.style.webkitTransform = 'scale(1.1)'; 
        // iframe.style.webkitBackgroundClip = 'brightness(1)'

        // const iframeDocument = iframe.contentWindow?.document;
        // // Change background color to red
        // if(iframeDocument)
        //   iframeDocument.body.style.backgroundColor = 'red';

    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setIsloading(false)
    }
  };

  return (
    <Loading isLoading={detailsPageLoading || isLoading }>
    <div className="my-2 flex flex-col">
      <div className="flex justify-end py-1">
        <button
          onClick={() => generatePDF("download")}
          disabled={ isLoading || detailsPageLoading || isDownloading}
          className={`mr-[28px] px-4 py-2 font-semibold text-[14px] flex items-center gap-2 ${isLoading || detailsPageLoading || isDownloading ? "bg-[#F87171]":"bg-[#e31c23]" } hover:bg-red-700 text-white rounded disabled:cursor-not-allowed`}
        >
          {isDownloading && <FaSpinner className="animate-spin" />}
          {isDownloading ? "Generating PDF..." : "Download PDF"}
        </button>
      </div>

{/* {isPdfUrl?.length ? <PdfViewer fileUrl={isPdfUrl}/>:""
} */}
      {/* <iframe
        id="pdf-iframe"
        // style={{ width: "100%", height: "80vh", border: "none" }}
        title="PDF Viewer"
        loading="lazy"
        className="h-[700px] self-center max-w-full rounded-2xl aspect-[0.75] w-full"
        // sandbox="allow-same-origin allow-scripts"
        allow="none"
        // width="100%"
      ></iframe> */}
      {
      isPdfUrl?.length > 1 &&
        <PdfViewer pdfUrl={isPdfUrl} numPages={numPages}/>
      }
    </div>
    </Loading>
  );
};

export default ResumePDFGenerator;
